<div class="border border-zen-neutralp90 bg-white rounded-lg p-4 h-fit min-h-full overflow-x-hidden sidebar-transition"
    (click)="logData(sectionRoutes)" [ngClass]="collapsed ? 'w-20':'w-60'" @listAnimation>
    <ng-container *ngFor="let section of sectionRoutes; let i = index">
        @if (section.label) {
        <div *ngIf="collapsable || !collapsed" class="flex flex-row items-stretch w-full sidebar-transition"
            [ngClass]="(collapsed && i != 0) ? '!h-0 pt-0 pb-0': 'h-12 pt-0.5 pb-2.5'">
            <div class="flex flex-row items-center h-8 w-full sidebar-transition overflow-hidden" [ngClass]="{
                'w-12 gap-0': collapsed,
                'justify-between w-full gap-2': !collapsed,
                'justify-center': collapsed && i == 0
                }">
                <p class="text-xs font-medium text-zen-primaryLight uppercase sidebar-transition whitespace-nowrap overflow-hidden"
                    [ngClass]="{
                        'w-[10.25rem]': i == 0 && !collapsed,
                        'w-full': i != 0 && !collapsed,
                        'w-0 opacity-0 ltr:translate-x-10 rtl:-translate-x-10': collapsed,
                    }">
                    {{ section.label }}
                </p>
                <button [style]="{ minWidth: '2rem',minHeight: '2rem' }" zenButton styles="ghost icon-8"
                    *ngIf="collapsable && i == 0" (click)="toggleCollapsed()" class="!bg-white">
                    <img class="w-5 h-5 sidebar-transition rtl:rotate-180"
                        [ngClass]="collapsed && 'ltr:rotate-180 rtl:!rotate-0'"
                        src="assets/img/svg/sidebar-open-close.svg" />
                </button>
            </div>
        </div>
        }
        <a [routerLink]="route.route.split('#')[0]" [matTooltip]="collapsed ? route.label : ''"
            [matTooltipPosition]="(language | language) ? 'left' : 'right'" routerLinkActive #link="routerLinkActive"
            [fragment]="route.route.includes('#') ? route.route.split('#')[1] : null" [TourStep]="route.tourStep"
            class="flex flex-row items-center h-12 btn rounded sidebar-transition px-3 overflow-hidden justify-center relative"
            *ngFor="let route of section.routes" [ngClass]="{
                'bg-exp/10 text-exp': link.isActive,
                'hover:bg-zen-background text-zen': !link.isActive,
                'w-12 gap-0': collapsed,
                'w-full gap-2': !collapsed
            }">
            <div *ngIf="route.icon?.length"
                class="w-5 h-5 flex justify-center items-center text-base absolute m-auto top-0 bottom-0 sidebar-transition"
                [ngClass]="{
                    'text-exp': link.isActive,
                    'text-zen-neutralp60': !link.isActive,
                    'ltr:left-3.5 rtl:right-3.5': collapsed,
                    'ltr:left-3 rtl:right-3': !collapsed
                }">
                <i [ngClass]="route.icon"></i>
            </div>
            <div class="w-5 h-5 min-w-[1.25rem]"></div>
            <p class="text-sm leading-5 whitespace-nowrap overflow-hidden sidebar-transition"
                [ngClass]="collapsed ? 'w-0 opacity-0 ltr:translate-x-5 rtl:-translate-x-5':'w-full'">{{ route.label }}
            </p>
        </a>
        <div class="h-8 flex flex-row items-center w-full"
            *ngIf="sectionRoutes.length > 1 && i < sectionRoutes.length - 1">
            <div class="h-px w-full bg-zen-neutralp90"></div>
        </div>
    </ng-container>
</div>